import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getDaysBetweenDates } from "../../Utils/leaveUtils";

const DateRange = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  submitted,
}) => {
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  const diffDays = getDaysBetweenDates(startDate, endDate);

  const handleStartChange = (date) => {
    setStartDate(date);
    if (startDateRef.current) {
      startDateRef.current.input.blur();
    }
    if (endDateRef.current) {
      endDateRef.current.setFocus();
    }
  };

  // dynamic border classes:
  const startBorderClass =
    submitted && !startDate ? "border-red-500" : "border-gray-300";
  const endBorderClass =
    submitted && !endDate ? "border-red-500" : "border-gray-300";

  return (
    <div className="flex justify-center">
      <div className="flex flex-wrap md:flex-nowrap items-center border border-gray-200 rounded-lg shadow-sm p-4 gap-4 bg-white w-full">
        {/* From */}
        <div className="flex flex-col flex-1 min-w-[150px]">
          <label className="text-sm text-[#142b70]/80 mb-1">From</label>
          <DatePicker
            ref={startDateRef}
            selected={startDate}
            onChange={handleStartChange}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            className={`w-full px-3 py-2 border ${startBorderClass} rounded-md focus:outline-none`}
            placeholderText="Select start date"
          />
        </div>

        {/* Days */}
        <div className="relative w-[80px] text-center px-4 flex-shrink-0">
          <span className="absolute -bottom-[20px] border rounded left-0 w-full text-sm text-[#142b70]/80">
            {diffDays ? `${diffDays} days` : "0 days"}
          </span>
        </div>

        {/* To */}
        <div className="flex flex-col flex-1 min-w-[150px]">
          <label className="text-sm text-[#142b70]/80 mb-1">To</label>
          <DatePicker
            ref={endDateRef}
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            className={`w-full px-3 py-2 border ${endBorderClass} rounded-md focus:outline-none`}
            placeholderText="Select end date"
          />
        </div>
      </div>
    </div>
  );
};

export default DateRange;
